"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/serviceSection.tsx */

import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeTwelveServiceSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Services" */
    sectionDiv0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Lab Test" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "We offer a wide range of reliable and accurate diagnostic tests to support your health at every stage." */
    sectionDiv0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "All Services" */
    sectionDiv0Div0Link0Span1SpanText?: ReactNode;
    /** Default: "Consult top doctors online for any health concern" */
    sectionDiv1DivText?: ReactNode;
    /** Default: "#" */
    sectionDiv1Link0LinkHref?: string;
    /** Default: "Connect within 60secs" */
    sectionDiv1Link0LinkText?: ReactNode;
    sectionDiv1Link0LinkVisible?: boolean;
    sectionDiv1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
};

const HomeTwelveServiceSectionGenerated: FC<HomeTwelveServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0H20H2Text = "Our",
    sectionDiv0Div0Div0H20H2Text2 = "Services",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Lab Test",
    sectionDiv0Div0Div0P0PText = "We offer a wide range of reliable and accurate diagnostic tests to support your health at every stage.",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionDiv0Div0Link0Span1SpanText = "All Services",
    sectionDiv1DivText = "Consult top doctors online for any health concern",
    sectionDiv1Link0LinkHref = "#",
    sectionDiv1Link0LinkText = "Connect within 60secs",
    sectionDiv1Link0LinkVisible,
    sectionDiv1Link0LinkRenderer,
    sectionDiv1Link0LinkProps,
}) => {
    return (
        <section className="services-section-twelve section pt-0">
            <div className="container">
                <div className="section-header section-header-twelve mb-0 wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div>
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                {" "}
                                {sectionDiv0Div0Div0H20H2Text}
                                <span className="text-primary">{sectionDiv0Div0Div0H20Span0SpanText}</span>
                                {sectionDiv0Div0Div0H20H2Text2}
                            </h2>
                        ))}
                        <p className="description">{sectionDiv0Div0Div0P0PText}</p>
                    </div>
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn btn-primary theme-11-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            <span className="icon one">
                                <i className="isax isax-arrow-right-1" />
                                {" "}
                            </span>
                            <span className="content">{sectionDiv0Div0Link0Span1SpanText}</span>
                            <span className="icon two">
                                <i className="isax isax-arrow-right-1" />
                                {" "}
                            </span>
                        </SmartLink>
                    ))}
                </div>
            </div>
            <div data-template-tag="ServicesTwelveSlider" />
            <div className="view-more">
                {sectionDiv1DivText}
                {" "}
                {renderNode(sectionDiv1Link0LinkVisible, sectionDiv1Link0LinkRenderer, (
                    <SmartLink href={sectionDiv1Link0LinkHref} className="link" {...(sectionDiv1Link0LinkProps ?? {})}>{sectionDiv1Link0LinkText}</SmartLink>
                ))}
            </div>
        </section>
    );
};

export default HomeTwelveServiceSectionGenerated;
